import { AppContent } from '../AppContent';

const footer: AppContent['footer'] = {
  footerContent: [
    {
      text: 'Cookies',
      link: 'https://www.bankofscotland.co.uk/helpcentre/privacy/cookies.html',
    },
    {
      text: 'Legal',
      link: 'https://business.bankofscotland.co.uk/business-home/legal.html',
    },
    {
      text: 'Privacy',
      link: 'https://business.bankofscotland.co.uk/business-home/legal/personal-and-business-data.html',
    },
    {
      text: 'Security',
      link: 'https://www.bankofscotland.co.uk/securityandprivacy/protecting-yourself-from-fraud.html',
    },
    {
      text: 'Lloyds Banking Group',
      link: 'https://www.lloydsbankinggroup.com',
    },
    {
      text: 'Rates and charges',
      link: 'https://business.bankofscotland.co.uk/business-home/rates-and-charges.html',
    },
  ],
};

export default footer;
